import { AgentTestOperation } from '@elementary/common-ui/types';

export const SEVERITY_OPTIONS = [
  { value: 'warn', label: 'Warning' },
  { value: 'error', label: 'Error' },
];

export const BREADCRUMB_LABELS: Record<AgentTestOperation, string> = {
  update: 'Changes Preview',
  create: 'Creation Preview',
  delete: 'Deletion Preview',
};

export const STORAGE_KEY = 'code_agent_config_preview_table';
